<template>
  <div v-if="items.length > 0" class="featured">
    <ContentBar :btns="false">
      <template #left>
        <h3 v-html="$t('market.there_are_other_items_you_may_like')" />
      </template>
    </ContentBar>
    <div class="market-items">
      <ItemMarket v-for="item in items" :key="item.asset_id" :item="item" />
    </div>
  </div>
</template>
<script setup>
import { getFeaturedItems } from '@/hook/market/feature.js';
import ItemMarket from '@/component/market/ItemMarket.vue';
import { onMounted, ref } from 'vue';
import { app_id } from '@/hook/market/game.js';
import ContentBar from '@/component/items-page/ContentBar.vue';

const items = ref([]);

onMounted(async () => {
  items.value = await getFeaturedItems(app_id.value);
});
</script>
